<template>
    <button
      class="k-button"
      :class="classes"
      @click="$emit('click')"
      :disabled="disabled"
    >
      <k-icon class="icon" v-if="icon && !loading" :name="icon"></k-icon>
      <k-icon v-if="loading" class="loading icon" name="loading"></k-icon>
      <div class="content">
        <slot />
      </div>
    </button>
</template>

<script>
import Icon from "./icon";
export default {
  name: "KilokButton",
  components: {
    "k-icon": Icon,
  },
  props: {
    icon: {},
    loading: {
      type: Boolean,
      default: false,
    },

    iconPosition: {
      type: String,
      default: "left",
      validator(value) {
        return value === "left" || value === "right";
      },
    },
    size:{
      type:String,
      default:"normal",
      validator(value){
        return ['big','normal','small'].indexOf(value)>=0
      }
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    classes(){
      return { [`icon-${this.iconPosition}`]: true ,[`${this.size}`]:true}
    }
  }
};
</script>

<style lang="scss">
 $button-height: 32px;
  $font-size: 14px;
  $button-bg: white;
  $border-radius: 4px;
  $color: #333;
  $border-color: #999;
  $border-color-hover: rgba(0,0,0);
  $background-color-active:rgba(238, 238, 238);
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  .k-button {margin: 1px; font-size: $font-size; height: $button-height; padding: 0 1em; vertical-align: middle; border-radius: $border-radius; border: 1px solid $border-color;
    background: $button-bg; display:inline-flex; justify-content: center; align-items: center;
    &:hover { border-color: $border-color-hover; cursor: pointer;}
    &:active { background-color: $background-color-active; }
    &:focus { outline: none; }
    > .content { order: 2; }
    > .icon { order: 1; margin-right: 0.1em; }
    &.icon-right {
    > .content { order: 1; }
    > .icon { order: 2; margin-right: 0em; margin-left: 0.1em; } }
    .loading { animation: spin 2s infinite linear; }
     &.big{ font-size: 18px;height:40px;}
    &.small{font-size:10px;height: 24px;}
    &[disabled] { border-color: #bbb; color: #bbb; cursor: not-allowed; &:active{background-color: white;}}
    }
   
</style>
